import { useEffect, useState } from 'react';

import { getQueue } from '../offline/offlineQueue';
import {
  pendingSegmentReviewsFromQueue,
  queueOwnerKey,
} from '../offline/pendingSegmentReviewsFromQueue';
import { currentQueueOwner } from '../offline/queueOwner';

const EMPTY: ReadonlyMap<string, boolean> = new Map();

/**
 * Marcas de «tramo revisado» encoladas sin red (id del tramo → revisado).
 *
 * Se relee la cola con el evento `offline-queue-changed` (el mismo que usa
 * `usePendingSegments`): al encolar aparece la superposición y al replayarse
 * desaparece, sin nada que limpiar a mano.
 */
export function usePendingSegmentReviews(): ReadonlyMap<string, boolean> {
  const [pending, setPending] = useState<ReadonlyMap<string, boolean>>(EMPTY);

  useEffect(() => {
    let cancelled = false;

    const refresh = () => {
      void getQueue().then((queue) => {
        if (cancelled) return;
        const next = pendingSegmentReviewsFromQueue(
          queue,
          queueOwnerKey(currentQueueOwner())
        );
        setPending(next.size === 0 ? EMPTY : next);
      });
    };

    refresh();
    window.addEventListener('offline-queue-changed', refresh);
    window.addEventListener('online', refresh);
    return () => {
      cancelled = true;
      window.removeEventListener('offline-queue-changed', refresh);
      window.removeEventListener('online', refresh);
    };
  }, []);

  return pending;
}
